import { retrieveProduct } from '@vfit/consumer/data-access';
import { setTrackLink, setTrackView } from '@vfit/shared/data-access';
import { useTracking } from '@vfit/shared/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';

const CoverageToolManualTagging = () => {
  const product = retrieveProduct();
  const pageProduct = {
    product_name: product?.slug,
    product_id: `${product?.offerId}`,
    product_price: product?.price && removeCurrency(product.price),
    product_category: 'fixed',
    product_quantity: '1',
  };

  const { trackView } = useTracking({
    event: ['tool_start'],
    event_label: 'manual address input',
    opts: {
      event_category: 'tools',
      page_type: 'address',
      page_section: 'fixed offers',
      page_subsection: 'coverage tool',
    },
    pageProduct,
  });

  setTrackView(trackView);
  setTrackLink(trackView);

  return null;
};

export default CoverageToolManualTagging;
